const queryKeys = Object.freeze({
  TASK: 'task',
  TODO: 'todo',
  DONE: 'done',
});

export default queryKeys;
